import React, { ReactElement } from 'react';
import Moment from 'react-moment';

const getDate = (date: Date | string | null) => (!date ? null : typeof date === 'string' ? new Date(date) : date);

// set ignoreUTC to true when passing in partial dates with time, so it doesn't interfere with the timestamp
export const convertDateTimeToMoment = (
    date: Date,
    format?: string,
    ignoreUTC: boolean = false,
): ReactElement | string => {
    const actualDate = getDate(date);

    return !actualDate || actualDate.getUTCFullYear() === 1 ? (
        ''
    ) : (
        <Moment
            format={format && format !== '{0:undefined}' ? format : 'DD-MMM-YYYY HH:mm:ss'}
            {...(!ignoreUTC && { utc: true })}
        >
            {actualDate}
        </Moment>
    );
};

/**
 * Creates a UTC date string in ISO format from a JavaScript date
 * @param input The JavaScript date
 * @param includeTime Whether to include the time in the date, default `false`
 */
export const assumeUtc = (input: Date | null, includeTime: boolean = false): string | undefined =>
    input
        ? new Date(
              Date.UTC(
                  input.getFullYear(),
                  input.getMonth(),
                  input.getDate(),
                  includeTime ? input.getHours() : 0,
                  includeTime ? input.getMinutes() : 0,
                  includeTime ? input.getSeconds() : 0,
                  includeTime ? input.getMilliseconds() : 0,
              ),
          ).toISOString()
        : undefined;

/**
 * Returns the date-only portion of the current UTC date
 */
export const getUTCDate = (): Date => {
    const now = new Date();
    return new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, 0, 0, 0);
};
